<template>
	<div class="home">
		<div class="top">
			<van-popup v-model="show" get-container="body" :style="{ height: '85%',width: '90%' }" :closeable="true">
				<div class="">
					<div class="plr20 bggrey  ft28" style="height: 6vh; line-height: 6vh;">申请人信息</div>
					<van-cell-group class="plr20">
						<van-cell title="申请人" :value="showForm.roposerName" />
						<van-cell title="申请人电话" :value="showForm.roposerPhone" />
						<van-cell title="申请人公司类型" :value="showForm.proposerType==1?'工程公司':'矿属单位'" />
						<van-cell v-if="showForm.proposerType==1" title="公司名称" :value="showForm.roposerCompany" />
					</van-cell-group>
					<div class="plr20 bggrey ft28" style="height: 6vh; line-height: 6vh;">审批者信息</div>
					<van-cell-group class="plr20">
						<van-cell title="审批者" :value="showForm.approverName" />
						<van-cell title="审批者电话" :value="showForm.approverPhone" />
					</van-cell-group>
					<div class="plr20 bggrey ft28" style="height: 6vh; line-height: 6vh;">报备信息</div>
					<van-cell-group class="plr20">
						<van-cell title="出矿时间" :value="showForm.leaveTime " />
						<van-cell title="出矿地点" :value="showForm.leaveLocName" />
						<van-cell title="车牌号" :value="showForm.truckNo" />
						<van-cell title="出矿事由" :value="showForm.leaveReason" />
					</van-cell-group>
					<div class="plr20 bggrey ft28" style="height: 6vh; line-height: 6vh;">出矿物资</div>
					<div v-for="(item, index) in showForm.goodsList" :key="index">
						<div class="bgwhite yellow2 ft30 pl30 bor-bt" style="height: 5.5vh; line-height: 5.5vh;">
							物资{{ index + 1 }}</div>
						<van-cell-group class="plr20">
							<van-cell title="物资名称" :value="item.goodsName" />
							<van-cell title="物资规格" :value="item.goodsModel" />
							<van-cell title="物资数量" :value="item.goodsCount" />
							<div class="flex alstart between mt20">
								<span class="ft30 w40">物资照片</span>
								<template v-if="item.goodsPhone.indexOf(',')!=-1">
									<div class="flex flex1 " style="flex-wrap: wrap;">
										<van-image width="20vw" height="20vw" v-for="(i,v) in item.goodsPhone.split(',')" :key="v"
											:src="i"  @click="imagePreview(item,v,1)" style="display: flex; word-wrap: break-word; word-break: normal;padding: 0 1vw 1vw 0;">
											<template v-slot:loading> 
												<van-loading type="spinner" size="20" />
											</template>
										</van-image>
									</div>
								</template>
								<template v-else>
									<div class="flex flex1 " style="flex-wrap: wrap;">
										<van-image width="20vw" height="20vw" :src="item.goodsPhone"  @click="imagePreview(item,0,1)" style="padding: 0 1vw 1vw 0;">
											<template v-slot:loading> 
												<van-loading type="spinner" size="20" />
											</template>
										</van-image>
									</div>
								</template>
							</div>
						</van-cell-group>
					</div>
					
					<div class="tc ptb10">
						<van-button type="danger" class="tc" @click="show=false">关闭</van-button>
					</div>
				</div>
			</van-popup>
			<div class="w100" style="height: 6vh; position: fixed;z-index: 100; ">
				<van-search v-model="personName" show-action placeholder="请输入搜索关键词" @search="onSearch">
					<template #action>
						<div @click="onSearch">搜索</div>
					</template>
				</van-search>
			</div>
			<div class="bggrey" style="height: 8vh;"></div>

			<van-pull-refresh class="bggrey" v-model="isLoading" @refresh="onRefresh">
				<div class="autoFixed">
					<van-list v-model="loading" :finished="finishedBottom" finished-text="没有更多了" @load="onLoad">
						<van-cell v-for="(item, index) in checkedHistoryList" :key="index" style="margin-top: 20px; padding: 0">
							<div class="main">
								<div class="history-left" style="margin-top: 20px;">
									<div class="yellow"> 出矿信息：</div>
									<div class="history-item">
										<span>审核者：</span>
										<span>{{ item.approverName }}</span>
									</div>
									<div class="history-item">
										<span>审核者手机号：</span>
										<span>{{ item.approverPhone }}</span>
									</div>
									<div class="history-item">
										<span>出矿事由：</span>
										<span>{{ item.leaveReason }}</span>
									</div>
									<div class="history-item">
										<span>出矿时间：</span>
										<span>{{ item.leaveTime }}</span>
									</div>
									<div class="history-item">
										<span> 申请人： </span>
										<span>{{ item.roposerName }}</span>
									</div>
									<div class="history-item">
										<span>申请人电话：</span>
										<span>{{ item.roposerPhone }}</span>
									</div>
									<div class="yellow">领导审核：</div>
									<van-row class="bggrey p-box1 mtb20"
										v-for="(list, index1) in item.goodsCheckerList" :key="index1">
										<van-col class="p-label1" span="6">{{list.checkerName}}</van-col>
										<!-- <van-col class="p-value1" span="7">{{list.checkerPhone}}</van-col> -->
										<van-col class="p-value1" span="6" v-if="list.checkStatus==0">待审核
										</van-col>
										<van-col class="p-value1 blue" span="6" @click="getRefuseReason(list)" v-if="list.checkStatus==1">通过
										</van-col>
										<van-col class="p-value1 red" span="6" @click="getRefuseReason(list)" v-if="list.checkStatus==2">拒绝
										</van-col>
										<van-col class="p-value1" span="12" v-if="list.createTime">{{list.createTime}}
										</van-col>
									</van-row>
								</div>
								<!-- <div class="hisotry-right"></div> -->

								<van-button plain type="info" size="small" class="userBtn" @click="getDetail(item)">详情
								</van-button>
							</div>
						</van-cell>
					</van-list>
				</div>
			</van-pull-refresh>
		</div>
	</div>
</template>
<script>
	// import tabs from "@/components/tabs.vue";
	import {
		tbGoodsReportGuardApptQuery,
	} from "@/apis/api";
	import {
		Toast,
		Dialog,
		ImagePreview,
	} from "vant";
	import {
		formatTime
	} from "@/utils/index";
	export default {
		data() {
			return {
				checkedHistoryList: [],
				pageNo: 1,
				pageSize: 10,
				total: 0,
				isLoading: false,
				loading: false,
				finishedBottom: false,
				show: false,
				showForm: {},
				personName: '',
			};
		},
		mounted() {
			document.title = "门岗物资出矿查询";
			this.onSearch();
		},
		methods: {
			imagePreview(item,list,index){
				var images,arr;
				if(index==1){
					if(item.goodsPhone.indexOf(',')!=-1){
						arr = item.goodsPhone.split(',');
						images = arr;
					}else{
						images = [item.goodsPhone]
					}
				}
				console.log(images);
				ImagePreview({
				  images,
				  startPosition: list,
					closeable: true,
				});
			},
			// 详情
			getDetail(item) {
				this.show = true;
				this.showForm = item;
			},
			// 拒绝原因
			getRefuseReason(list){
				Dialog.alert({
				  title: '原因',
				  message: list.refuseReason,
				  theme: 'round-button',
				}).then(() => {
				});
			},
			// 搜索
			onSearch() {
				this.onRefresh(1);
			},
			onRefresh(index) {
				this.pageNo = 1;
				this.pageSize = 10;
				this.isLoading = true;
				this.loading = true;
				console.log(666);
				tbGoodsReportGuardApptQuery({
					pageNo: this.pageNo,
					pageSize: this.pageSize,
					personName: this.personName,
					roposerPhone: '',
				}).then(res => {
					this.isLoading = false;
					this.loading = false;
					if(res.code!==200){
						this.finishedBottom = true;
						Toast(res.message);
					}else{
						if (index != 1) {
							Toast('刷新成功');
						}
						this.checkedHistoryList = res.result.records;
						this.total = res.result.total;
						if (this.checkedHistoryList.length == this.total) {
							this.finishedBottom = true;
						}else{
							this.finishedBottom = false;
						}
					}
				});
			},
			onLoad(e) {
				if (this.isLoading) return;
				console.log('e');
				this.pageNo++;
				tbGoodsReportGuardApptQuery({
					pageNo: this.pageNo,
					pageSize: this.pageSize,
					personName: this.personName,
					roposerPhone: '',
				}).then(res => {
					if(res.code!==200){
						this.finishedBottom = true;
						Toast(res.message);
					}else{
						this.isLoading = false;
						this.loading = false;
						this.checkedHistoryList = this.checkedHistoryList.concat(res.result.records);
						if (this.checkedHistoryList.length == this.total) {
							this.finishedBottom = true;
						}
					}
					
				});
			},

		},
		// components: {
		// 	tabs,
		// },
	};
</script>

<style lang="less" scoped>
	.modals {
		// padding: 10px 30px;
	}

	.autoFixed {
		background: #f3f3f3;
		min-height: 100vh;
		padding: 0 20px;
		position: relative;

		.userBtn {
			position: absolute;
			right: 20px;
			top: 20px;
			width: 94px;
			height: 40px;
			text-align: center;
			line-height: 40px;

			background: none;
			border-radius: 5px;
			color: #4597FF;
		}

		.main {
			box-sizing: content-box;
			background: #ffffff;
			// display: flex;
			// justify-content: space-between;
			// align-items: center;
			width: 100%;
			border-radius: 5px;
			padding: 0 24px;
			box-sizing: border-box;
			position: relative;

			.roomName {
				position: absolute;
				left: 20px;
				top: 20px;
				color: #64b0ff;
				font-weight: bold;
			}

			.hisotry-right {
				img {
					width: 150px;
					height: 130px;
				}
			}

			.history-item {
				margin-bottom: 15px;

				span {
					font-size: 28px;
					color: #333;
				}
			}
		}
	}
</style>
